module.exports = __webpack_public_path__ + "static/07-452c7e0a431e523a1c69a475ca909c82.png";